"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgUp = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21.585 16.882a1.333 1.333 0 01-1.885-.048L12 8.624l-7.7 8.21a1.333 1.333 0 11-1.933-1.837L12 4.751l9.633 10.246a1.333 1.333 0 01-.048 1.885z", clipRule: "evenodd" })));
};
exports.default = SvgUp;
//# sourceMappingURL=Up.js.map